import axios from "axios";

const API_BASE_URL =
  import.meta?.env?.VITE_API_URL ||
  process.env.REACT_APP_API_URL ||
  "https://graficosb-production.up.railway.app";

const API = `${API_BASE_URL}/api/salud`;
const opts = { timeout: 60000 };

export async function obtenerBeneficiarios() {
  const { data } = await axios.get(`${API}/beneficiarios`, opts);
  return data.rows;
}
export async function obtenerTipo(year) {
  const { data } = await axios.get(`${API}/tipo`, { ...opts, params: { year } });
  return data;
}
export async function obtenerSexo(year) {
  const { data } = await axios.get(`${API}/sexo`, { ...opts, params: { year } });
  return data;
}
export async function obtenerIndicador(key) {
  const { data } = await axios.get(`${API}/indicadores/${key}`, opts);
  return data.rows;
}
export async function obtenerEdad(year) {
  const { data } = await axios.get(`${API}/edad`, { ...opts, params: { year } });
  return data;
}
export async function obtenerVigencia(year) {
  const { data } = await axios.get(`${API}/vigencia`, { ...opts, params: { year } });
  return data;
}
export async function obtenerRegion(year) {
  const { data } = await axios.get(`${API}/region`, { ...opts, params: { year } });
  return data;
}
export const formatMiles = (v) => (typeof v === "number" ? v.toLocaleString("es-CL") : v);
